var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473_9448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.2086,
    cy: 41.8732,
    r: 30.4572,
    fill: "white",
    fillOpacity: 0.17,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2807 29.374C42.2537 28.9587 40.1635 28.9587 38.1365 29.374C37.507 29.503 37.0223 30.0069 36.9178 30.6409L36.8409 31.1075C36.2079 34.9482 36.2079 38.8666 36.8409 42.7073L36.9178 43.1739C37.0223 43.8079 37.507 44.3118 38.1365 44.4408C40.1635 44.8562 42.2537 44.8562 44.2807 44.4408C44.9102 44.3118 45.395 43.8079 45.4994 43.1739L45.5764 42.7073C46.2093 38.8666 46.2093 34.9482 45.5764 31.1075L45.4994 30.6409C45.395 30.0069 44.9102 29.503 44.2807 29.374Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1309 39.4001C31.7126 39.3176 32.251 39.7224 32.3334 40.304L32.9724 44.8134C33.145 46.0318 34.1108 46.9844 35.3314 47.1403C39.2337 47.6387 43.1835 47.6387 47.0858 47.1403C48.3064 46.9844 49.2722 46.0318 49.4448 44.8134L50.0838 40.304C50.1663 39.7224 50.7046 39.3176 51.2863 39.4001C51.868 39.4825 52.2727 40.0208 52.1903 40.6025L51.5513 45.1119C51.2443 47.279 49.5264 48.9734 47.3554 49.2507C45.6672 49.4663 43.9705 49.5927 42.2724 49.63V55.346C42.2724 55.9335 41.7961 56.4097 41.2086 56.4097C40.6211 56.4097 40.1449 55.9335 40.1449 55.346V49.63C38.4467 49.5927 36.75 49.4663 35.0618 49.2507C32.8908 48.9734 31.173 47.279 30.8659 45.1119L30.2269 40.6025C30.1445 40.0208 30.5492 39.4825 31.1309 39.4001Z",
    fill: "#D8D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473_9448",
    x: 0.00173187,
    y: 0.666405,
    width: 82.4137,
    height: 82.4133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.37481
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_9448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473_9448",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/MicOn.6c8b3de3a6cb9f4b857c38ab54f5bc67.svg";
export { ForwardRef as ReactComponent };